import * as React from 'react';
import { IReferral } from '../../../../models/IReferral';
import { ReferralSendButton } from './ReferralSendButton';
import { ReferralResponseButtons } from './ReferralResponseButtons';
import { ReferralWithdrawButton } from './ReferralWithdrawButton';
import { ReferralAnswerButtons } from './ReferralAnswerButtons';
import { ReferralResetAnswerButton } from './ReferralResetAnswerButton';
import { ReferralClosedButtons } from './ReferralClosedButtons';
import { ReferralSaveButton } from './ReferralSaveButton';

interface IReferralActionButtons {
    referral?: IReferral;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
    gotTreatmentsReported?: boolean;
    isParaply: boolean;
}

export const ReferralActionButtons: React.FunctionComponent<IReferralActionButtons> = ({ referral, changeSuccessMessage, changeErrorMessage, getReferral, gotTreatmentsReported, isParaply }) => {


        return (
            <>
                {
                    referral ?
                        <>
                            <ReferralSaveButton isEditable={referral.isEditable} canWriteAnswer={referral.canWriteAnswer} referralId={referral.referralId} getReferral={getReferral} referralStatus={referral.referralStatus} changeErrorMessage={changeErrorMessage} changeSuccessMessage={changeSuccessMessage} />
                            <ReferralSendButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} isEditable={referral.isEditable} referralId={referral.referralId} />
                            <ReferralResponseButtons canSendResponse={referral.canSendResponse} />
                            {
                                referral.referralId ?
                                    <>
                                        <ReferralWithdrawButton canWithdrawReferral={referral.canWithdrawReferral} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} referralId={referral.referralId} />
                                        <ReferralAnswerButtons canCloseReferral={referral.canCloseReferral} gotReportedTreatments={gotTreatmentsReported ?? false} referralId={referral.referralId} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} isParaply={isParaply} />
                                        <ReferralResetAnswerButton canResetReferral={referral.canResetReferral} referralId={referral.referralId} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} />
                                    </>
                                    : null
                            }
                            <ReferralClosedButtons referral={referral} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} />
                        </>
                        : null
                }
            </>
        )
    }
